import "./LabOsComponent.scss";
import React, {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {setCurrentNavParams, setSideMenuView} from "../../store/actions/header.action";
import ENV from "../../constants/ENV";
import {CommonService} from "../../shared/services";
import useSystemLockUpdateLabOs from "../../shared/hooks/useSystemLockUpdateLabOs";

interface LabOsComponentProps {

}

const LabOsComponent = (props: LabOsComponentProps) => {

    useSystemLockUpdateLabOs();
    const dispatch = useDispatch();

    const token = useSelector((state: any) => state.account.token);
    let LabUrl = `${ENV.LAB_OS_URL}?token=${token}`

    const {selectedLab} = useSelector((state: any) => state.selectedLab);

    if ( selectedLab) {
        LabUrl = `${ENV.LAB_OS_URL}?token=${token}&labId=${selectedLab}`
    } else{
        CommonService._communications.LabSelectionSubject.next(true);
    }

    useEffect(() => {
        dispatch(setCurrentNavParams("Lab OS", "LabOS"));
        dispatch(setSideMenuView('compact'));
    }, [dispatch]);

    return (
        <div className={'lab-os-component'}>
            <iframe
                src={LabUrl}
                // src={`http://192.168.0.7:3005?token=${token}`}
                className={'labOs-iframe'}
                width="100%"
                height="100%"
                title={'LabOs'}
                loading={'eager'}
            />
        </div>
    );

};

export default LabOsComponent;
